import { ChangeEvent, useId } from 'react';
import classNames from 'classnames';
import NSSwitch from 'bricks/NSSwitch/NSSwitch';
import NSLabel from 'bricks/NSLabel/NSLabel';
import './MapStyleToggle.scss';

interface IMapStyleToggleProps {
    checked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    className?: string;
}

/** Chip overlaid on a map that switches it between regular and satellite views. */
const MapStyleToggle = ({ checked, onChange, className }: IMapStyleToggleProps) => {
    const switchId = useId();

    return (
        <div className={classNames('MapStyleToggle', 'd-flex', 'align-items-center', className)}>
            <NSSwitch
                id={switchId}
                name={switchId}
                checked={checked}
                onChange={onChange}
                ariaLabel="Toggle satellite view"
            />
            <NSLabel for={switchId} className="MapStyleToggle__label mb-0 text-white font-14 font-weight-semibold">Satellite</NSLabel>
        </div>
    );
};

export default MapStyleToggle;
